const SquareUkraine = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 22 16">
      <g clipPath="url(#a)">
        <rect width="22" height="16" fill="#FFDA2C" rx="2" />
        <path fill="#3A99FF" fillRule="evenodd" d="M0 0H22V8H0V0Z" clipRule="evenodd" />
      </g>
      <defs>
        <clipPath id="a">
          <path fill="white" d="M0 0H22V16H0z" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default SquareUkraine;
